module.exports = __webpack_public_path__ + "assets/528aa6d430243795c5350661b1e1f3e8.mp3";